export default "-- ClickBench Q3\nselect avg(userid)\nfrom hits;";